<template>
  <div>
    <header class="ts-app-header capture-shell">
      <div class="ts-stepper">
        <div class="progress">
            <div class="progress-bar-filler" style="width:0%;"></div>
            <div class="progress-bar-ending" :style="calculatedPercent"></div>
        </div>
        <ul class="ts-stepper-steps">
            <li style="left:0%" v-bind:class="{ current: currentRouteName == 'ProgramInfo'}"><span>Program Info</span></li>
            <li style="left:25%" v-bind:class="{ current: currentRouteName == 'ProgramActivities'}"><span>Activities</span></li>
            <li style="left:50%" v-bind:class="{ current: currentRouteName == 'ProgramKnowledge'}"><span>Knowledge</span></li>
            <li style="left:75%" v-bind:class="{ current: currentRouteName == 'ProgramSkills'}"><span>Skills</span></li>
            <li style="left:100%" v-bind:class="{ current: currentRouteName == 'ProgramEssentialSkills'}"><span>Essential Skills</span></li>
        </ul>
      </div>
    </header>
    <main class="ts-app-capture sga wider">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import { LockIcon } from 'vue-feather-icons';

export default {
  components: {
    LockIcon
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    calculatedPercent() {
      if (this.currentRouteName == 'ProgramInfo') {
        return 'width: 0%;';
      } if (this.currentRouteName == 'ProgramActivities') {
        return 'width: 25%;';
      } if (this.currentRouteName == 'ProgramKnowledge') {
        return 'width: 50%;';
      } if (this.currentRouteName == 'ProgramSkills') {
        return 'width: 75%;';
      } if (this.currentRouteName == 'ProgramEssentialSkills') {
        return 'width: 100%;';
      } 
    },
    currentCriteria() {
      return this.$store.state.apprentice.current_apprentice_criteria;
    },
  },
  destroyed() {
      
    if(this.$route.matched.find(c => c.path === "/apprentice/programcriteria") === undefined) {
        window.sessionStorage.removeItem("currentCriteria");
        this.currentCriteria.id = null;
        this.currentCriteria.subjectArea = null;
        this.currentCriteria.level = null;
        this.currentCriteria.pathway = null;
        this.currentCriteria.sgaHiddenExtras = null;
        this.currentCriteria.sgaKnowledge = null;
        this.currentCriteria.sgaSkills = null;
        this.currentCriteria.sgaMindset = null;
    } 
  },
  methods: {

  }
};
</script>